import axios from "axios";
import { getAnonymousID, getSessionID } from "redline-client-sdk";

import { isAcOnCpHost } from "@libs/utils/helpers/isAcOnCpHost";

import { getAppName } from "@libs/utils/helpers/getAppName";
import { getIdentityBaseURL } from "./config";

const isCustomBuild = isAcOnCpHost();
const isDev = import.meta.env.VITE_ENV === "dev";

const blockedUserAgents = ["Mediapartners-Google"];

const identityApiClient = axios.create({
	headers: {
		"Content-Type": "application/json",
		"x-anonymous-id": getAnonymousID(),
		"x-session-id": getSessionID(),
	},
	validateStatus: (status) => {
		return status >= 200 && status < 300;
	},
});

identityApiClient.interceptors.request.use(
	(config) => {
		config.headers["X-App-Id"] = getAppName();

		if (!config.baseURL) {
			config.baseURL = getIdentityBaseURL();
		}
		const isEngageSignIn = config.url?.includes("/engage/signin");
		if (isEngageSignIn) {
			const userAgent = navigator.userAgent;
			const params = new URLSearchParams(window.location.search);

			const isBlocked =
				blockedUserAgents.some((agent) =>
					userAgent.toLowerCase().includes(agent.toLowerCase()),
				) && !params.has("p");

			if (isBlocked) {
				return Promise.reject(
					new axios.Cancel("Acesso bloqueado: user agent não permitido"),
				);
			}
		}

		if (config.url?.includes("/auth/refresh-token") && isCustomBuild) {
			config.baseURL = isDev
				? "https://dev-identity.consumidorpositivo.com.br"
				: "https://identity.consumidorpositivo.com.br";
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default identityApiClient;
